/**
 * Static request action types
 */

export default {
  ERROR_REQUEST_UNSUPPORTED: "error/ERROR_REQUEST_UNSUPPORTED",
  ERROR_RISE: "ERROR_RISE",
  ERROR_DROP: "ERROR_DROP"
};
